import {
  createListSearchParams,
  ListOrder,
  ListPagination,
} from 'api/list-params'
import { pipe } from 'fp-ts/function'
import { decodeJsonWithTotal, get } from 'lib/request'

import { TProjectHistoryItem, TSubevent } from './project-history.codecs'

export type GetProjectHistoryInput = {
  projectId: string
  pagination: ListPagination
  order: ListOrder
  dateFrom?: string
  dateTo?: string
  actionType: string
}

export const getProjectHistory = async ({
  projectId,
  pagination,
  order,
  dateFrom,
  dateTo,
  actionType,
}: GetProjectHistoryInput) => {
  const params = createListSearchParams({ pagination, order })

  if (dateFrom) params.set('date_from', dateFrom)
  if (dateTo) params.set('date_to', dateTo)

  if (actionType && actionType !== 'all') {
    params.set('action_type', actionType)
  }

  return pipe(
    await get('api/projects/:projectId/history', {
      params: { projectId },
      query: params,
    }),
    decodeJsonWithTotal(TProjectHistoryItem, pagination),
  )
}

export type ProjectHistorySubEventAction =
  | 'import_from_file'
  | 'import_from_repo'
  | 'import_from_gitlab'
  | 'import_from_figma'

export type GetProjectHistorySubeventsInput = {
  projectId: string
  action: ProjectHistorySubEventAction
  pagination: ListPagination
  order: ListOrder
  createdAt: string
}

export const getProjectHistorySubevents = async ({
  projectId,
  action,
  pagination,
  order,
  createdAt,
}: GetProjectHistorySubeventsInput) => {
  const params = createListSearchParams({ pagination, order })

  params.set('action', action)
  params.set('created_at', createdAt)

  return pipe(
    await get('api/projects/:projectId/history/subevents', {
      params: { projectId },
      query: params,
    }),
    decodeJsonWithTotal(TSubevent, pagination),
  )
}
